import React, { useContext } from 'react'
import SspContext from '../../../../../../contexts/SspContext'
import appConfig from '../../../../../../../app.config'
import { useTranslation } from 'react-i18next'

import {
	checkIsMobile,
	getCurrency,
	stringifyNum,
} from '../../../../../../../shared'

const InfoBox = ({ depositData, depositInfo }: any) => {
	const { t } = useTranslation()
	const isMobile = checkIsMobile()
	const { isCard, productType } = useContext(SspContext)

	let bankAccountNumbersDe = isCard?.isCard
		? ['DE77512202000070508402', 'ESSEDEFFXXX']
		: ['DE06202208000000024118', 'SXPYDEHH']

	let bankAccountNumbersNo = isCard?.isCard
		? '3633.32.77160'
		: '3633.53.85432'

	return (
		<div className="overview d-flex flex-column p-3 mr-3">
			<div className="inner-box d-flex justify-content-between p-3">
				<div className="d-flex flex-column">
					{productType === 'Deposit_Fixed' ? (
						<div>{t('DepositFixedAccount')}</div>
					) : (
						<div>{t('DepositAccount')}</div>
					)}
					<div className="mb-4">
						{appConfig.country === 'de' && (
							<>{depositData?.accountNumber}</>
						)}
					</div>
					<div>{t('BankBalance')}</div>
					<div>
						{stringifyNum(depositData?.balance, {
							currency: getCurrency(),
							style: 'currency',
						})}
					</div>
				</div>
				<div className="d-flex flex-column text-right">
					<div className="">{t('CurrentRate')}</div>
					<div>{`${depositData?.interestRate} %`}</div>
				</div>
			</div>
			{appConfig.country === 'de' ? (
				<>
					<div className="pt-4">
						<b>{t('PresetDisbursementAccount')}</b>
					</div>
					<div className="d-flex justify-content-between py-3">
						<div className="d-flex flex-column">
							<div className="py-1">{t('IBAN')}</div>
							<div className="py-1">{t('Bic')}</div>
						</div>
						<div className="d-flex flex-column text-right">
							<div className="py-1">{depositInfo[0]}</div>
							<div className="py-1">{depositInfo[1]}</div>
						</div>
					</div>
					{!isMobile ? (
						<>
							<div className="pt-4">
								{productType === 'Deposit_Fixed' ? (
									<b>{t('DepositFixedInformation')}</b>
								) : (
									<b>{t('DepositInformation')}</b>
								)}
							</div>
							<div className="d-flex justify-content-between flex-column py-3">
								<div className="d-flex flex-row">
									<div className="py-1 w-50">
										{t('CustomerReference')}
									</div>
									<div className="py-1 w-50 text-right">
										{depositData?.accountNumber}
									</div>
								</div>
								<div className="d-flex flex-row">
									<div className="py-1 w-50">{t('IBAN')}</div>
									<div className="py-1 w-50 text-right">
										{bankAccountNumbersDe[0]}
									</div>
								</div>
								<div className="d-flex flex-row">
									<div className="py-1 w-50">{t('Bic')}</div>
									<div className="py-1 w-50 text-right">
										{bankAccountNumbersDe[1]}
									</div>
								</div>
							</div>
						</>
					) : (
						<>
							<div className="pt-4">
								{productType === 'Deposit_Fixed' ? (
									<b>{t('DepositFixedInformation')}</b>
								) : (
									<b>{t('DepositInformation')}</b>
								)}
							</div>
							<div className="d-flex flex-column mt-3">
								<div className="pt-1">
									<b>{t('CustomerReference')}:</b>
								</div>
								<div className="pb-1">
									{depositData?.accountNumber}
								</div>

								<div className="mt-3">{`${t('IBAN')}: ${
									bankAccountNumbersDe[0]
								}`}</div>
								<div>{`${t('Bic')}: ${
									bankAccountNumbersDe[1]
								}`}</div>
							</div>
						</>
					)}
				</>
			) : (
				<div className={isMobile ? 'p-3' : 'pt-4'}>
					{productType === 'Deposit_Fixed' ? (
						<b>{t('DepositFixedInformation')}</b>
					) : (
						<b>{t('DepositInformation')}</b>
					)}
					<div className="d-flex justify-content-between py-3">
						<div className="d-flex flex-column">
							<div className="py-1">{t('CustomerReference')}</div>
							<div className="py-1">{t('BankAccountNumber')}</div>
						</div>
						<div className="d-flex flex-column text-right">
							<div className="py-1">
								{depositData?.accountNumber}
							</div>
							<div className="py-1">{bankAccountNumbersNo}</div>
						</div>
					</div>
				</div>
			)}
		</div>
	)
}

export default InfoBox
